import {Injectable} from '@angular/core';
import {ApiClientService} from '../api-client.service';
import {catchError} from 'rxjs/operators';
import {Observable} from 'rxjs';
import {NotificationBuildingSettings} from '../../types/api-response/notification';

@Injectable()
export class NotificationsApiService {

    constructor(
        private api: ApiClientService
    ) {
    }

    checkSender(email: string) {
        const url = `/v1/public/check_sender/${email}`;
        return this.api.getJson('domainNotifications', url)
            .pipe(
                catchError(error => {
                    this.api.errorHandler(error, 'Failed to verify entered email.');
                    throw error;
                })
            );
    }

    addSender(email: string) {
        const url = '/v1/public/add_sender';
        const data = {email: email};
        return this.api.post('domainNotifications', url, data)
            .pipe(
                catchError(error => {
                    this.api.errorHandler(error, 'Failed to send verification.');
                    throw error;
                })
            );
    }

    getBuildingSettings(buildingId: number): Observable<NotificationBuildingSettings> {
        const url = `/v1/building_settings/${buildingId}`;
        return this.api.getJson('domainNotifications', url) .pipe(
            catchError(error => {
                this.api.errorHandler(error, 'Failed to get settings.');
                throw error;
            })
        );
    }

    updateBuildingSettings(buildingId: number, data) {
        const url = `/v1/building_settings/${buildingId}`;
        return this.api.patch('domainNotifications', url, data)
            .pipe(
                catchError(error => {
                    this.api.errorHandler(error, 'Failed to update settings.');
                    throw error;
                })
            );
    }
}



// WEBPACK FOOTER //
// /app/src/app/services/api/notifications-api.service.ts